<div ngbDropdown
     display="dynamic"
     placement="bottom-end"
     autoClose="outside">
  <button id="share"
          class="btn btn-primary"
          ngbDropdownToggle
          ngbTooltip="Share"
          placement="bottom"
          container="body"
          autoClose="outside"
          style="padding-right: 5px !important;">
    <i class="fa-light fa-share-nodes"></i>
  </button>
  <div ngbDropdownMenu>
    <button
      id="share-copy-clipboard"
      ngbDropdownItem
      #tooltip="ngbTooltip"
      placement="right"
      ngbTooltip="Copied!"
      triggers="manual"
      container="body"
      (click)="copyToClipboard()">
      <i class="fa-light fa-clipboard me-1"></i>Copy to clipboard
    </button>
    <button id="share-new-tab"
            ngbDropdownItem
            (click)="openInNewTab()">
      <i class="fa-light fa-up-right-from-square me-1"></i>Open in a new tab
    </button>
    <button id="share-email"
            ngbDropdownItem
            (click)="shareByEmail()">
      <i class="fa-light fa-envelope me-1"></i>Share by email
    </button>
  </div>
</div>
